import { ActionTypes } from "../constants";

export default function browse(state = {}, action) {
  switch(action.type) {
    case ActionTypes.SET_GOALS_LIST:
      return Object.assign({}, state, action.payload);
    case ActionTypes.SET_GOAL_SETUP_DATA:
      return Object.assign({}, state, action.payload);

    default:
      return state;
  }
}